/**
 * Recursively finds the nearest scrollable parent.
 * Checks for CSS overflow properties: 'auto' or 'scroll'.
 */
export const getScrollParent = node => {
  if (node === null || !(node instanceof Element)) return window;

  const isScrollable = element => {
    const style = window.getComputedStyle(element);
    const overflowY = style.getPropertyValue('overflow-y');

    return /(auto|scroll)/.test(overflowY);
  };

  // If the current node is the body/html or has overflow-y set to auto/scroll
  if (node === document.body || node === document.documentElement || isScrollable(node)) {
    return node;
  }

  return getScrollParent(node.parentNode);
};

/**
 * Main function to set the scroll position of a component's scroll parent.
 * @param {string} id - The ID of the React component/DOM element.
 * @param {number} x - The desired Y-coordinate (top position).
 */
export const setScrollYById = (id, x) => {
  const element = document.getElementById(id);
  if (!element) return;

  const scrollParent = getScrollParent(element);

  if (scrollParent === window) {
    // Window uses scrollTo method
    window.scrollTo({ top: x, behavior: 'smooth' });
  } else {
    // Standard DOM elements use the scrollTop property
    scrollParent.scrollTop = x;
  }
};
